import { Select } from '@dreryk/react-components';

import { translationKeys } from '../../translations';
import { PatientMedicalInformationRemoveFormController } from '../PatientMedicalInformationRemoveForm.types';

import { PatientMedicalInformationRemoveReasonFieldFormValue } from './PatientMedicalInformationRemoveReasonField.types';
import { PATIENT_MEDICAL_INFORMATION_REMOVE_REASON_ITEMS } from './PatientMedicalInformationRemoveReasonField.constants';
import { useTriggerLabelExtractor } from './PatientMedicalInformationRemoveReasonField.hooks';

type PatientMedicalInformationRemoveReasonFieldProps = Pick<PatientMedicalInformationRemoveFormController, 'register'>;

export const PatientMedicalInformationRemoveReasonField = (
   props: PatientMedicalInformationRemoveReasonFieldProps
): JSX.Element => {
   const triggerLabelExtractor = useTriggerLabelExtractor();

   return (
      <Select<PatientMedicalInformationRemoveReasonFieldFormValue>
         triggerLabelExtractor={triggerLabelExtractor}
         label={translationKeys.reasonForRemoval}
         controller={props.register('reason', { required: true })}
         testId={'reason'}
         defaultValue={'MISTAKE'}
      >
         <Select.List items={PATIENT_MEDICAL_INFORMATION_REMOVE_REASON_ITEMS}>
            {(item: PatientMedicalInformationRemoveReasonFieldFormValue) => (
               <Select.Item<PatientMedicalInformationRemoveReasonFieldFormValue>
                  item={item}
                  testId={item}
                  label={translationKeys.reasonMap[item]}
               />
            )}
         </Select.List>
      </Select>
   );
};
